import { Injectable } from '@angular/core';

import { DirectoryModel } from '@classes/wiki/directory-model.model';

@Injectable({
  providedIn: 'root'
})
export class UtilitiyService {

  constructor() { }

  stripHtml(html: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  encryptObject(toEncrypt: DirectoryModel): string {
    return btoa(unescape(encodeURIComponent(JSON.stringify(toEncrypt))));
  }

  encryptString(toEncrypt: string): string {
    return btoa(unescape(encodeURIComponent(toEncrypt)));
  }

  decryptString(toDecrypt: string): string {
    return decodeURIComponent(escape(atob(toDecrypt)));
  }
}
